"use strict";

exports.__esModule = true;
var _Timer = require("./Timer");
Object.keys(_Timer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Timer[key]) return;
  exports[key] = _Timer[key];
});
var _withTimer = require("./withTimer");
Object.keys(_withTimer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _withTimer[key]) return;
  exports[key] = _withTimer[key];
});